import Vue from 'vue'
import Router from 'vue-router'
import store from '@/./store'

import { hasUserPermission } from '@/utils/permissionsHandler'
import { appConfig } from '@/config.js'

import UserLogin from './routes/userLogin'
import Dashboard from './routes/dashboard'
import Orders from './routes/orders'
import JobsForProof from './routes/jobsForProof'
import CuttingJobs from './routes/cuttingJobs'
import Configurations from './routes/configurations'
import Jobs from './routes/jobs'
import Reports from './routes/reports'
import Maintenance from './routes/maintenance'
import Documents from './routes/documents'
import Notes from './routes/notes'
import Complaints from './routes/complaints'
import Wiki from './routes/wiki'
import Customers from './routes/customers'
import Calculations from './routes/calculations'
import Purchases from './routes/purchases'
import UserTasks from './routes/userTasks'
import Shipments from './routes/shipments'
import Shipping from './routes/shipping'
import Campaigns from './routes/campaigns'
import Administration from './routes/administration'
import Outdoors from './routes/outdoors'
import Prepress from './routes/Prepress'
import ReportsAndAnalysis from './routes/reportsAndAnalysis'
import { errorHandler } from '@/utils/errorHandler'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        ...UserLogin,
        ...Dashboard,
        ...Notes,
        ...UserTasks,
        ...Customers,
        ...Campaigns,
        ...Calculations,
        ...Orders,
        ...Jobs,
        ...JobsForProof,
        ...CuttingJobs,
        ...Reports,
        ...Maintenance,
        ...Documents,
        ...Shipments,
        ...Shipping,
        ...Complaints,
        ...Purchases,
        ...Configurations,
        ...Administration,
        ...Outdoors,
        ...ReportsAndAnalysis,
        ...Prepress,
        ...Wiki,
    ],
    scrollBehavior() {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({ x: 0, y: 0 })
            }, 400)
        })
    }
})

// Navigation Guards
router.beforeEach((to, from, next) => {
    store.dispatch('toggleMainLoader', true)

    const title = to.meta.title

    title
        ? (document.title = `${appConfig.common.appName} - ${title}`)
        : (document.title = appConfig.common.appName)

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // Jeśli strona wymaga autoryzacji przekieruj na formularz logowania
        if (!store.getters.loggedIn) {
            next({
                name: 'userLogin',
            })
        } else {
            if (to.meta.permission) {
                if (hasUserPermission(to.meta.permission)) {
                    next()
                } else {
                    store.dispatch('showNotification', {
                        type: 'error',
                        message: 'Nie posiadasz uprawnień dla tego widoku.',
                    })

                    next(from.path)
                }
            } else {
                next()
            }
        }

    // Jeśli autoryzacja przebiegła pomyślnie przekieruj na domyślny widok
    } else if (to.matched.some(record => record.meta.requiresVisitor)) {
        if (store.getters.loggedIn) {
            next({
                name: 'dashboard'
            })
        } else {
            next()
        }

    // Jeśli adres URL nie pasuje do żadnego routingu przekieruj na domyślny widok
    } else if (!to.matched.length) {
        next({ path: from.path })
    } else {
        next()
    }
})

router.afterEach(() => {
    store.dispatch('toggleMainLoader', false)

    // Sprawdzenie czy istnieje nowa wersja aplikacji
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(reg => reg.update())
    }
})

router.onError(error => {
    errorHandler(error)
    store.dispatch('toggleMainLoader', false)
})

export default router
